import { EMPTY_DOC_CHARGE_DATA_CRITERIA } from "presentation/constant/DocumentPreview/DocChargeDataCriteria";
import { DocumentPreviewConstant } from "presentation/constant/DocumentPreview/DocumentPreviewConstant";
import { useDocumentPreviewVM } from "presentation/hook/DocumentPreview/useDocumentPreviewVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useDocumentPreviewTracked } from "presentation/store/DocumentPreview/DocumentPreviewProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useMemo } from "react";
import { DialogModal, FieldType, HPHButton, IconButton, IFieldValue } from "veronica-ui-component/dist/component/core";

const AddRemoveRejectApproveModal: React.FC = () => {
    const documentPreviewVM = useDocumentPreviewVM();
    const [documentPreviewState] = useDocumentPreviewTracked();
    const { editSearchCriteria, currentSelectedData, showApproveRejectPanel, approveRejactReasonCode } = documentPreviewState;
    const messageBarVM = useMessageBarVM();

    const onRejectClicked = () => {
        let criteria = {
            ...EMPTY_DOC_CHARGE_DATA_CRITERIA
        }
        criteria = {
            ...EMPTY_DOC_CHARGE_DATA_CRITERIA,
            approveRejactReasonCode: approveRejactReasonCode,
            approveReject: showApproveRejectPanel,
            draftInvoiceNo: currentSelectedData?.draftDocNo as string ?? null,
            etd: currentSelectedData?.etd as Date ?? null,
            consortiumCode: currentSelectedData?.consortiumCode as string ?? null,
            vesselCode: currentSelectedData?.vesselCode as string ?? null,
            voyageCode: currentSelectedData?.voyageCode as string ?? null,
            billToCompany: currentSelectedData?.billToCompany as string ?? null,
            docHdrId: Number(currentSelectedData.id)
        }
        documentPreviewVM.onApproveOrReject(criteria).then(async (data) => {
            await documentPreviewVM.searchDocChargeData(currentSelectedData, editSearchCriteria);
            if (!data) {
                messageBarVM.showSuccess(showApproveRejectPanel === "APPROVE" ? "Approve success!" : "Reject success!");
            } else {
                messageBarVM.showError(data ?? (showApproveRejectPanel === "APPROVE" ? "Fail to approve record(s)." : "Fail to reject record(s)."));
            }
            documentPreviewVM.cancelApproveRejectReasonModal();
        });
    }

    const memoRejectReason = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "350px", marginBottom: "24px" }} >
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={approveRejactReasonCode || ''}
                fieldValue={approveRejactReasonCode}
                fieldLabel={DocumentPreviewConstant.EditTable.APPROVE_REJECT_REASON}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'approveRejactReasonCode'}
                maxLength={200}
                options={showApproveRejectPanel === "APPROVE" ? documentPreviewState.dynamicOptions.approveReasonDropdownOptions : documentPreviewState.dynamicOptions.rejectReasonDropdownOptions}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) => documentPreviewVM.onApproveRejectReasonChange(fieldValue && fieldValue.toString())}
                requiredFieldList={['approveRejactReasonCode']} />
        </div>
        , [approveRejactReasonCode, documentPreviewState.dynamicOptions.approveReasonDropdownOptions, documentPreviewState.dynamicOptions.rejectReasonDropdownOptions, documentPreviewVM, showApproveRejectPanel])



    return <><DialogModal style={{ minWidth: '600px', minHeight: '450px' }}
        appendTo='self'
        showButton={false}
        visible={showApproveRejectPanel ? true : false}
        positions="center"
        resizable={false}
        header={
            <div className="im-charge-data-search-confirm-modal-header">
                <span className="name">{(showApproveRejectPanel === "APPROVE" ? "Approve " : "Reject ") + DocumentPreviewConstant.EditTable.APPROVE_REJECT_REASON}</span>
                <IconButton fileName='Icon-cross' size="medium" onClick={documentPreviewVM.cancelApproveRejectReasonModal} tooltipDisable={true} />
            </div>
        }
        dialogContent={
            <div className="im-charge-data-search-confirm-modal-content">

                <CriteriaItemContainer>
                    {memoRejectReason}
                </CriteriaItemContainer>

            </div>
        }
        className="im-charge-data-search-confirm-modal"
        footer={
            <div className="im-charge-data-search-confirm-modal-footer">
                <HPHButton disabled={!approveRejactReasonCode || approveRejactReasonCode.length === 0} label={(showApproveRejectPanel === "APPROVE" ? "Approve" : "Reject")} size={'Small'} theme={'Primary'} onClick={onRejectClicked} />
            </div>
        }
    /></>;
};

export default memo(AddRemoveRejectApproveModal);